import { AnyAction } from "redux";
import {
  ScheduleDay,
  ScheduleTime,
  ScheduleTimeAvailableData,
} from "../../core/http/service/SchedulingService";
import { ScheduleConsultType } from "../../core/http/service/SchedulingService";
import {
  GET_SELECTED_TIME_AVAILABLE,
  RESET_SELECTED_TIME_AVAILABLE,
  SET_SCHEDULE_CONSULT_TYPE,
  SET_SCHEDULING_PATIENT,
  SET_SELECTED_TIME_AVAILABLE,
} from "../actions/scheduling";

export interface ISchedulingReducer {
  selectedTimeAvailable?: ScheduleTimeAvailableData;
  selectedScheduleDay?: ScheduleDay;
  selectedScheduleHour?: ScheduleTime;
  modalOpen: boolean;
  consultType?: ScheduleConsultType;
  pacienteId?: string;
  empresaId?: string;
}

const initialState: ISchedulingReducer = {
  selectedTimeAvailable: undefined,
  modalOpen: false,
};

export const SchedulingReducer = (state = initialState, action: AnyAction) => {
  switch (action.type) {
    case RESET_SELECTED_TIME_AVAILABLE: {
      return {
        ...state,
        selectedTimeAvailable: undefined,
        modalOpen: false,
        selectedScheduleDay: undefined,
        selectedScheduleHour: undefined,
        pacienteId: undefined,
        empresaId: undefined,
      };
    }
    case SET_SELECTED_TIME_AVAILABLE: {
      return {
        ...state,
        selectedTimeAvailable: action.selectedTimeAvailable,
        modalOpen: true,
        selectedScheduleDay: action.selectedScheduleDay,
        selectedScheduleHour: action.selectedScheduleHour,
        pacienteId: action.pacienteId ?? state.pacienteId,
        empresaId: action.empresaId ?? state.empresaId,
      };
    }
    case SET_SCHEDULING_PATIENT: {
      return {
        ...state,
        pacienteId: action.pacienteId,
        empresaId: action.empresaId,
      };
    }
    case GET_SELECTED_TIME_AVAILABLE: {
      return state;
    }
    case SET_SCHEDULE_CONSULT_TYPE: {
      return {
        ...state,
        consultType: action.consultType,
      };
    }
    default: {
      return state;
    }
  }
};
